import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import "./Complaint.css";
import { useTranslation } from "react-i18next";
import { _t, getCookie, checkPermission } from "../../../../functions/Functions";
import { Helmet } from "react-helmet";
import ComplaintsSidebar from "./ComplaintsSidebar";
import { UserContext } from "../../../../contexts/User";
import { AuditContext } from "../../../../contexts/Audit";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import { NavLink } from "react-router-dom";
import DataTable from "../../../common/DataTable";

export default function TicketsList() {
  const { t } = useTranslation();
  const { authUserInfo } = useContext(UserContext);
  const { loading: auditLoading } = useContext(AuditContext);
  
  const [ticketsList, setTicketsList] = useState({});
  const [ticketsForSearch, setTicketsForSearch] = useState([]);
  const [searchedTicket, setSearchedTicket] = useState({ searched: false, list: [] });
  const [dataPaginating, setDataPaginating] = useState(false);
  const [loading, setLoading] = useState(false);

  const searchRef = useRef();

  useEffect(() => {
    fetchTickets(1);
  }, []);

  const fetchTickets = async (page = 1) => {
    setDataPaginating(true);
    setLoading(true);
    try {
      const url = `${BASE_URL}/complaints?page=${page}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` }
      });
      
      if (response.data && response.data.length > 0) {
        setTicketsList(response.data[0]);
        setTicketsForSearch(response.data[1]);
      } else if (response.data && response.data.data) {
        // Fallback structure
        setTicketsList(response.data.data[0]);
        setTicketsForSearch(response.data.data[1]);
      }
    } catch (error) {
      console.error("Error fetching tickets", error);

    } finally {
      setDataPaginating(false);
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedTicket({ ...searchedTicket, searched: false });
    } else {
      let searchedList = ticketsForSearch?.filter((item) => {
        let lowerCaseTicketNo = (item.ticket_no || item.id || "").toString().toLowerCase();
        let lowerCaseRemarks = (item.remarks || "").toLowerCase();
        return (
          lowerCaseTicketNo.includes(searchInput) ||
          lowerCaseRemarks.includes(searchInput)
        );
      }) || [];
      
      setSearchedTicket({
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleFetchData = (page) => {
    fetchTickets(page);
  };
  console.log("abcd6",ticketsList)
  const getListData = useCallback(() => {
    if (searchedTicket.searched) {
      return searchedTicket.list;
    }
    return ticketsList?.data || [];
  }, [searchedTicket, ticketsList]);

  const onClearSearch = () => {
    setSearchedTicket({ ...searchedTicket, searched: false });
    if (searchRef.current) {
      searchRef.current.value = "";
    }
  };

  const COLUMNS = [
    { 
      label: "ID", 
      render: (item, i) => searchedTicket.searched
        ? i + 1
        : i + 1 + ((ticketsList?.current_page || 1) - 1) * (ticketsList?.per_page || 0)
    },
    { label: "Ticket No", render: (item) => item.ticket_no || item.id },
    { label: "Status", render: (item) => item.status_label || item.status },
    { label: "Priority", render: (item) => item.severity_label || item.priority },
    { label: "Remarks", render: (item) => item.remarks },
    {
      label: "Action", render: (item) => (
        <div className="d-flex justify-content-center">
          <NavLink
            title="Follow Up"
            className="btn btn-info ml-2 rounded-sm"
            to={`/dashboard/complaints/complaint-tickets/${item.id}`}
            style={{ height: "1.7rem", width: "1.7rem" }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <i className="fa fa-comments" aria-hidden="true" style={{ fontSize: '14px', color: 'white' }}></i>
            </div>
          </NavLink>
          <NavLink
            title="Resolve"
            className="btn btn-success ml-2 rounded-sm"
            to={`/dashboard/complaints/complaint-resolve/${item.id}`}
            style={{ height: "1.7rem", width: "1.7rem" }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <i className="fa fa-check-circle" aria-hidden="true" style={{ fontSize: '14px', color: 'white' }}></i>
            </div>
          </NavLink>
        </div>
      )
    }
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Tickets List"))}</title>
      </Helmet>

      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* Left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ComplaintsSidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                  <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                    <ul className="t-list fk-breadcrumb">
                      <li className="fk-breadcrumb__list">
                        <span className="t-link fk-breadcrumb__link text-capitalize">
                          {!searchedTicket.searched
                            ? _t(t("Tickets List"))
                            : _t(t("Search Result"))}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-lg-7">
                    <div className="row gx-3 align-items-center">
                      <div className="col-md-12 t-mb-15 mb-md-0">
                        <div className="input-group">
                          <div className="form-file">
                            <input
                              ref={searchRef}
                              type="text"
                              className="form-control border-0 form-control--light-1 rounded-left"
                              placeholder={_t(t("Search by ticket no or remarks..."))}
                              onChange={handleSearch}
                              disabled={loading || dataPaginating}
                            />
                          </div>
                          <button className="btn btn-primary rounded-right" type="button">
                            <i className="fa fa-search" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <DataTable
                loading={loading || dataPaginating || auditLoading || authUserInfo.permissions === null}
                data={getListData()}
                columns={COLUMNS}
                emptyText="No data available"
                pagination={{
                  isPageLoading: loading || dataPaginating,
                  isPagination: true,
                  pageCount: ticketsList?.last_page,
                  currentPage: ticketsList?.current_page,
                  from: ticketsList?.from,
                  to: ticketsList?.to,
                  total: ticketsList?.total,
                }}
                handleFetchData={handleFetchData}
                searchPayload={{
                  isSearched: searchedTicket.searched,
                  onClearSearch
                }}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
